import React, { useState } from 'react';
import { Edit2, Info, HeartPulse, Sparkles, ChevronDown, ChevronUp, CreditCard } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';
const pulseScoreData = [{
  month: 'Apr',
  score: 75
}, {
  month: 'May',
  score: 74
}, {
  month: 'Jun',
  score: 75
}, {
  month: 'Jul',
  score: 76
}, {
  month: 'Aug',
  score: 75
}, {
  month: 'Sep',
  score: 74
}, {
  month: 'Oct',
  score: 75
}, {
  month: 'Nov',
  score: 76
}, {
  month: 'Dec',
  score: 78
}, {
  month: 'Jan',
  score: 80
}, {
  month: 'Feb',
  score: 81
}, {
  month: 'Mar',
  score: 82
}];
const healthScoreData = [{
  month: 'Apr',
  score: 86
}, {
  month: 'May',
  score: 87
}, {
  month: 'Jun',
  score: 86
}, {
  month: 'Jul',
  score: 88
}, {
  month: 'Aug',
  score: 87
}, {
  month: 'Sep',
  score: 88
}, {
  month: 'Oct',
  score: 89
}, {
  month: 'Nov',
  score: 88
}, {
  month: 'Dec',
  score: 89
}, {
  month: 'Jan',
  score: 90
}, {
  month: 'Feb',
  score: 89
}, {
  month: 'Mar',
  score: 88
}];
const paymentScoreData = [{
  month: 'Apr',
  score: 74
}, {
  month: 'May',
  score: 73
}, {
  month: 'Jun',
  score: 72
}, {
  month: 'Jul',
  score: 74
}, {
  month: 'Aug',
  score: 72
}, {
  month: 'Sep',
  score: 70
}, {
  month: 'Oct',
  score: 69
}, {
  month: 'Nov',
  score: 67
}, {
  month: 'Dec',
  score: 66
}, {
  month: 'Jan',
  score: 67
}, {
  month: 'Feb',
  score: 69
}, {
  month: 'Mar',
  score: 68
}];
function PositiveIndicator() {
  return <div className="flex items-end gap-0.5 shrink-0 mt-1" data-id="element-1317">
      <div className="w-1 h-1.5 bg-green-500 rounded-sm" data-id="element-1318" />
      <div className="w-1 h-2.5 bg-green-500 rounded-sm" data-id="element-1319" />
      <div className="w-1 h-3.5 bg-green-500 rounded-sm" data-id="element-1320" />
    </div>;
}
function NegativeIndicator() {
  return <div className="flex items-end gap-0.5 shrink-0 mt-1" data-id="element-1321">
      <div className="w-1 h-1.5 bg-red-500 rounded-sm" data-id="element-1322" />
      <div className="w-1 h-2.5 bg-red-500 rounded-sm" data-id="element-1323" />
      <div className="w-1 h-3.5 bg-red-500 rounded-sm" data-id="element-1324" />
    </div>;
}
function ScoreTooltip({
  active,
  payload,
  label,
  color
}: any) {
  if (active && payload && payload.length) {
    return <div className="bg-white rounded-lg border border-gray-200 shadow-sm px-3 py-2" data-id="element-1325">
        <p className="text-xs text-gray-500 mb-1" data-id="element-1326">{label}</p>
        <div className="flex items-center gap-2" data-id="element-1327">
          <div className="w-2.5 h-2.5 rounded-full shrink-0" style={{
          backgroundColor: color
        }} data-id="element-1328" />
          <span className="text-sm font-semibold text-gray-900" data-id="element-1329">
            {payload[0].value}
          </span>
        </div>
      </div>;
  }
  return null;
}
export function OverviewTab() {
  const [healthExpanded, setHealthExpanded] = useState(true);
  const [paymentExpanded, setPaymentExpanded] = useState(true);
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1330">
      {/* Top Row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1331">
        {/* Credit Settings */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 lg:col-span-1" data-id="element-1332">
          <div className="flex justify-between items-center mb-6" data-id="element-1333">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-1334">Credit Settings</h3>
            <button className="w-8 h-8 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center text-white transition-colors" data-id="element-1335">
              <Edit2 className="w-4 h-4" data-id="element-1336" />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-y-5 gap-x-4" data-id="element-1337">
            <div data-id="element-1338">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1339">
                Credit Limit
              </p>
              <p className="text-sm text-gray-600" data-id="element-1340">$50,000</p>
            </div>
            <div data-id="element-1341">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1342">
                Recommended Limit
              </p>
              <p className="text-sm text-gray-600" data-id="element-1343">$50,000</p>
            </div>
            <div data-id="element-1344">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1345">
                Outstanding Balance
              </p>
              <p className="text-sm text-gray-600" data-id="element-1346">$12,450</p>
            </div>
            <div data-id="element-1347">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1348">
                AP Contact
              </p>
              <p className="text-sm text-gray-600" data-id="element-1349">Angela Martin</p>
            </div>
            <div data-id="element-1350">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1351">
                Terms
              </p>
              <p className="text-sm text-gray-600" data-id="element-1352">Net 30</p>
            </div>
            <div data-id="element-1353">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1354">
                Purchasing Contact
              </p>
              <p className="text-sm text-gray-600" data-id="element-1355">Dwight Schrute</p>
            </div>
            <div data-id="element-1356">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1357">
                Late Pay Penalty
              </p>
              <p className="text-sm text-gray-600" data-id="element-1358">1.5%</p>
            </div>
            <div data-id="element-1359">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1360">
                Company Officer
              </p>
              <p className="text-sm text-gray-600" data-id="element-1361">Michael Scott</p>
            </div>
            <div data-id="element-1362">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1363">
                Date Last Approved
              </p>
              <p className="text-sm text-gray-600" data-id="element-1364">2/20/2026</p>
            </div>
            <div data-id="element-1365">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-1366">
                Group
              </p>
              <p className="text-sm text-gray-600" data-id="element-1367">Paper & Office Supplies</p>
            </div>
          </div>
        </div>

        {/* Pulse Score */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 lg:col-span-2 flex flex-col" data-id="element-1368">
          <div className="flex items-center gap-2 mb-4" data-id="element-1369">
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1370">Pulse Score</h3>
            <Info className="w-4 h-4 text-gray-400 cursor-help" data-id="element-1371" />
          </div>
          <div className="flex gap-6 mb-6" data-id="element-1372">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-100 border-2 border-green-500" data-id="element-1373">
              <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-1374"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-1375">
                Low Risk
              </span>
            </div>
          </div>
          <div className="flex-1 min-h-[200px] relative" data-id="element-1376">
            <div className="absolute top-0 right-0 flex items-center gap-2 text-xs text-gray-500 z-10" data-id="element-1377">
              <div className="w-3 h-3 bg-black rounded-sm" data-id="element-1378"></div>
              Pulse Score
            </div>
            <ResponsiveContainer width="100%" height="100%" data-id="element-1379">
              <LineChart data={pulseScoreData} margin={{
              top: 20,
              right: 0,
              left: -20,
              bottom: 0
            }} data-id="element-1380">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1381" />
                <XAxis dataKey="month" hide data-id="element-1382" />
                <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#6B7280'
              }} data-id="element-1383" />
                <Tooltip content={<ScoreTooltip color="#22c55e" data-id="element-1385" />} data-id="element-1384" />
                <ReferenceLine y={75} stroke="#22c55e" strokeDasharray="4 4" data-id="element-1386" />
                <ReferenceLine y={30} stroke="#ef4444" strokeDasharray="4 4" data-id="element-1387" />
                <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={{
                r: 3,
                fill: '#22c55e',
                stroke: '#22c55e',
                strokeWidth: 2
              }} activeDot={{
                r: 6,
                fill: '#22c55e',
                stroke: '#fff',
                strokeWidth: 2
              }} data-id="element-1388" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Health Score */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1389">
        <button onClick={() => setHealthExpanded(!healthExpanded)} className="w-full p-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors border-b border-gray-100" data-id="element-1390">
          <div className="flex items-center gap-3" data-id="element-1391">
            <HeartPulse className="w-5 h-5 text-gray-700" data-id="element-1392" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1393">Health Score</h3>
            <Info className="w-4 h-4 text-gray-400" data-id="element-1394" />
            <div className="flex items-center gap-2 px-3 py-1 rounded-full border-2 border-green-500 bg-white ml-2" data-id="element-1395">
              <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-1396"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-1397">88</span>
            </div>
            <Sparkles className="w-4 h-4 text-indigo-400 ml-1 animate-sparkle cursor-pointer" title="Ask Pulse AI about this score" data-id="element-1398" />
          </div>
          {healthExpanded ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1399" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1400" />}
        </button>

        {healthExpanded && <div className="p-5" data-id="element-1401">
            <p className="text-base text-gray-600 mb-6" data-id="element-1402">
              DUNDER MIFFLIN PAPER COMPANY has a 1.2% probability of insolvency
              or bankruptcy in the next 12 months.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-1403">
              {/* Negative Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1404">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-1405">
                  Negative Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-1406">
                  <div className="flex items-start gap-2" data-id="element-1407">
                    <NegativeIndicator data-id="element-1408" />
                    <span className="text-sm text-gray-600" data-id="element-1409">
                      Recent DBT increase trend (67% MoM)
                    </span>
                  </div>
                </div>
              </div>

              {/* Positive Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1410">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-1411">
                  Positive Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-1412">
                  <div className="flex items-start gap-2" data-id="element-1413">
                    <PositiveIndicator data-id="element-1414" />
                    <span className="text-sm text-gray-600" data-id="element-1415">
                      Years in business (77 years)
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-1416">
                    <PositiveIndicator data-id="element-1417" />
                    <span className="text-sm text-gray-600" data-id="element-1418">
                      Average monthly revenue over twelve months
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-1419">
                    <PositiveIndicator data-id="element-1420" />
                    <span className="text-sm text-gray-600" data-id="element-1421">
                      Strong Z-Score (3.42) and low debt-to-equity
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-1422">
                    <PositiveIndicator data-id="element-1423" />
                    <span className="text-sm text-gray-600" data-id="element-1424">
                      Stable employee headcount trend
                    </span>
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div className="lg:col-span-2 h-[200px]" data-id="element-1425">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1426">
                  <LineChart data={healthScoreData} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-1427">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1428" />
                    <XAxis dataKey="month" hide data-id="element-1429" />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B7280'
                }} data-id="element-1430" />
                    <Tooltip content={<ScoreTooltip color="#22c55e" data-id="element-1432" />} data-id="element-1431" />
                    <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={{
                  r: 3,
                  fill: '#22c55e',
                  stroke: '#22c55e',
                  strokeWidth: 2
                }} activeDot={{
                  r: 6,
                  fill: '#22c55e',
                  stroke: '#fff',
                  strokeWidth: 2
                }} data-id="element-1433" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>}
      </div>

      {/* Payment Score */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1434">
        <button onClick={() => setPaymentExpanded(!paymentExpanded)} className="w-full p-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors border-b border-gray-100" data-id="element-1435">
          <div className="flex items-center gap-3" data-id="element-1436">
            <CreditCard className="w-5 h-5 text-gray-700" data-id="element-1437" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1438">Payment Score</h3>
            <Info className="w-4 h-4 text-gray-400" data-id="element-1439" />
            <div className="flex items-center gap-2 px-3 py-1 rounded-full border-2 border-yellow-500 bg-white ml-2" data-id="element-1440">
              <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" data-id="element-1441"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-1442">68</span>
            </div>
            <Sparkles className="w-4 h-4 text-indigo-400 ml-1 animate-sparkle cursor-pointer" title="Ask Pulse AI about this score" data-id="element-1443" />
          </div>
          {paymentExpanded ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1444" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1445" />}
        </button>

        {paymentExpanded && <div className="p-5" data-id="element-1446">
            <p className="text-base text-gray-600 mb-6" data-id="element-1447">
              DUNDER MIFFLIN PAPER COMPANY has a 12.3% probability of late
              payment, indicating moderate risk.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-1448">
              {/* Negative Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1449">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-1450">
                  Negative Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-1451">
                  <div className="flex items-start gap-2" data-id="element-1452">
                    <NegativeIndicator data-id="element-1453" />
                    <span className="text-sm text-gray-600" data-id="element-1454">
                      Average 60+ day overdue balance ratio
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-1455">
                    <NegativeIndicator data-id="element-1456" />
                    <span className="text-sm text-gray-600" data-id="element-1457">
                      Recent DBT increase (6 to 10 days)
                    </span>
                  </div>
                </div>
              </div>

              {/* Positive Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1458">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-1459">
                  Positive Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-1460">
                  <div className="flex items-start gap-2" data-id="element-1461">
                    <PositiveIndicator data-id="element-1462" />
                    <span className="text-sm text-gray-600" data-id="element-1463">
                      DBT well below industry average
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-1464">
                    <PositiveIndicator data-id="element-1465" />
                    <span className="text-sm text-gray-600" data-id="element-1466">
                      Your AR consistently 2-4 days
                    </span>
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div className="lg:col-span-2 h-[200px]" data-id="element-1467">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1468">
                  <LineChart data={paymentScoreData} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-1469">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1470" />
                    <XAxis dataKey="month" hide data-id="element-1471" />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B7280'
                }} data-id="element-1472" />
                    <Tooltip content={<ScoreTooltip color="#eab308" data-id="element-1474" />} data-id="element-1473" />
                    <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={{
                  r: 3,
                  fill: '#eab308',
                  stroke: '#eab308',
                  strokeWidth: 2
                }} activeDot={{
                  r: 6,
                  fill: '#eab308',
                  stroke: '#fff',
                  strokeWidth: 2
                }} data-id="element-1475" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}